import { jsx as i, jsxs as H, Fragment as se } from "react/jsx-runtime";
import * as t from "react";
import * as Oe from "react-dom";
import { c as Re } from "../../../../index-rKs9bXHr.js";
import { u as Ne, c as b, a as q, b as rt } from "../../../../index-DjWSt7QJ.js";
import { u as lt, c as st } from "../../../../index-DmErOS-o.js";
import { c as ct, u as B, P as A, S as it } from "../../../../index-Bm60c36x.js";
import { P as at, D as dt } from "../../../../index-C3-XQVnN.js";
import { h as ut, u as pt, R as ft, F as mt } from "../../../../index-CkWkb05K.js";
import { u as Pe } from "../../../../index-jREDPgkq.js";
import { c as De, R as ht, A as vt, C as gt, a as St } from "../../../../index-HL5IY2_2.js";
import { u as wt } from "../../../../index-BZPx6jYI.js";
import { V as Ct } from "../../../../index-DcHdoXdn.js";
import { c as Ce } from "../../../../clsx-OuTLNxxd.js";
import { I as Ee } from "../../../../icon-BnqXyiyH.js";
import "../../icon/iconsList.js";
var xt = [" ", "Enter", "ArrowUp", "ArrowDown"], yt = [" ", "Enter"], ce = "Select", [ue, pe, It] = st(ce), [oe, mo] = ct(ce, [
  It,
  De
]), fe = De(), [Tt, $] = oe(ce), [_t, Pt] = oe(ce), Le = (l) => {
  const {
    __scopeSelect: a,
    children: e,
    open: c,
    defaultOpen: s,
    onOpenChange: d,
    value: o,
    defaultValue: r,
    onValueChange: n,
    dir: p,
    name: v,
    autoComplete: C,
    disabled: _,
    required: P,
    form: T
  } = l, u = fe(a), [g, x] = t.useState(null), [f, h] = t.useState(null), [O, D] = t.useState(!1), ne = lt(p), [R = !1, k] = Ne({
    prop: c,
    defaultProp: s,
    onChange: d
  }), [G, Z] = Ne({
    prop: o,
    defaultProp: r,
    onChange: n
  }), F = t.useRef(null), W = g ? T || !!g.closest("form") : !0, [z, K] = t.useState(/* @__PURE__ */ new Set()), U = Array.from(z).map((N) => N.props.value).join(";");
  return /* @__PURE__ */ i(ht, { ...u, children: /* @__PURE__ */ H(
    Tt,
    {
      required: P,
      scope: a,
      trigger: g,
      onTriggerChange: x,
      valueNode: f,
      onValueNodeChange: h,
      valueNodeHasChildren: O,
      onValueNodeHasChildrenChange: D,
      contentId: Pe(),
      value: G,
      onValueChange: Z,
      open: R,
      onOpenChange: k,
      dir: ne,
      triggerPointerDownPosRef: F,
      disabled: _,
      children: [
        /* @__PURE__ */ i(ue.Provider, { scope: a, children: /* @__PURE__ */ i(
          _t,
          {
            scope: l.__scopeSelect,
            onNativeOptionAdd: t.useCallback((N) => {
              K((V) => new Set(V).add(N));
            }, []),
            onNativeOptionRemove: t.useCallback((N) => {
              K((V) => {
                const j = new Set(V);
                return j.delete(N), j;
              });
            }, []),
            children: e
          }
        ) }),
        W ? /* @__PURE__ */ H(
          tt,
          {
            "aria-hidden": !0,
            required: P,
            tabIndex: -1,
            name: v,
            autoComplete: C,
            value: G,
            onChange: (N) => Z(N.target.value),
            disabled: _,
            form: T,
            children: [
              G === void 0 ? /* @__PURE__ */ i("option", { value: "" }) : null,
              Array.from(z)
            ]
          },
          U
        ) : null
      ]
    }
  ) });
};
Le.displayName = ce;
var ke = "SelectTrigger", Ve = t.forwardRef(
  (l, a) => {
    const { __scopeSelect: e, disabled: c = !1, ...s } = l, d = fe(e), o = $(ke, e), r = o.disabled || c, n = B(a, o.onTriggerChange), p = pe(e), v = t.useRef("touch"), [C, _, P] = ot((u) => {
      const g = p().filter((h) => !h.disabled), x = g.find((h) => h.value === o.value), f = nt(g, u, x);
      f !== void 0 && o.onValueChange(f.value);
    }), T = (u) => {
      r || (o.onOpenChange(!0), P()), u && (o.triggerPointerDownPosRef.current = {
        x: Math.round(u.pageX),
        y: Math.round(u.pageY)
      });
    };
    return /* @__PURE__ */ i(vt, { asChild: !0, ...d, children: /* @__PURE__ */ i(
      A.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": o.contentId,
        "aria-expanded": o.open,
        "aria-required": o.required,
        "aria-autocomplete": "none",
        dir: o.dir,
        "data-state": o.open ? "open" : "closed",
        disabled: r,
        "data-disabled": r ? "" : void 0,
        "data-placeholder": et(o.value) ? "" : void 0,
        ...s,
        ref: n,
        onClick: b(s.onClick, (u) => {
          u.currentTarget.focus(), v.current !== "mouse" && T(u);
        }),
        onPointerDown: b(s.onPointerDown, (u) => {
          v.current = u.pointerType;
          const g = u.target;
          g.hasPointerCapture(u.pointerId) && g.releasePointerCapture(u.pointerId), u.button === 0 && u.ctrlKey === !1 && u.pointerType === "mouse" && (T(u), u.preventDefault());
        }),
        onKeyDown: b(s.onKeyDown, (u) => {
          const g = C.current !== "";
          !(u.ctrlKey || u.altKey || u.metaKey) && u.key.length === 1 && _(u.key), !(g && u.key === " ") && xt.includes(u.key) && (T(), u.preventDefault());
        })
      }
    ) });
  }
);
Ve.displayName = ke;
var He = "SelectValue", Be = t.forwardRef(
  (l, a) => {
    const { __scopeSelect: e, className: c, style: s, children: d, placeholder: o = "", ...r } = l, n = $(He, e), { onValueNodeHasChildrenChange: p } = n, v = d !== void 0, C = B(a, n.onValueNodeChange);
    return q(() => {
      p(v);
    }, [p, v]), /* @__PURE__ */ i(
      A.span,
      {
        ...r,
        ref: C,
        style: { pointerEvents: "none" },
        children: et(n.value) ? /* @__PURE__ */ i(se, { children: o }) : d
      }
    );
  }
);
Be.displayName = He;
var bt = "SelectIcon", Fe = t.forwardRef(
  (l, a) => {
    const { __scopeSelect: e, children: c, ...s } = l;
    return /* @__PURE__ */ i(A.span, { "aria-hidden": !0, ...s, ref: a, children: c || "▼" });
  }
);
Fe.displayName = bt;
var Rt = "SelectPortal", We = (l) => /* @__PURE__ */ i(at, { asChild: !0, ...l });
We.displayName = Rt;
var ee = "SelectContent", Ke = t.forwardRef(
  (l, a) => {
    const e = $(ee, l.__scopeSelect), [c, s] = t.useState();
    if (q(() => {
      s(new DocumentFragment());
    }, []), !e.open) {
      const d = c;
      return d ? Oe.createPortal(
        /* @__PURE__ */ i(Ue, { scope: l.__scopeSelect, children: /* @__PURE__ */ i(ue.Slot, { scope: l.__scopeSelect, children: /* @__PURE__ */ i("div", { children: l.children }) }) }),
        d
      ) : null;
    }
    return /* @__PURE__ */ i(je, { ...l, ref: a });
  }
);
Ke.displayName = ee;
var L = 10, [Ue, X] = oe(ee), Nt = "SelectContentImpl", je = t.forwardRef(
  (l, a) => {
    const {
      __scopeSelect: e,
      position: c = "item-aligned",
      onCloseAutoFocus: s,
      onEscapeKeyDown: d,
      onPointerDownOutside: o,
      //
      // PopperContent props
      side: r,
      sideOffset: n,
      align: p,
      alignOffset: v,
      arrowPadding: C,
      collisionBoundary: _,
      collisionPadding: P,
      sticky: T,
      hideWhenDetached: u,
      avoidCollisions: g,
      //
      ...x
    } = l, f = $(ee, e), [h, O] = t.useState(null), [D, ne] = t.useState(null), R = B(a, (m) => O(m)), [k, G] = t.useState(null), [Z, F] = t.useState(
      null
    ), W = pe(e), [z, K] = t.useState(!1), U = t.useRef(!1);
    t.useEffect(() => {
      if (h) return ut(h);
    }, [h]), pt();
    const N = t.useCallback(
      (m) => {
        const [I, ...E] = W().map((w) => w.ref.current), [y] = E.slice(-1), S = document.activeElement;
        for (const w of m)
          if (w === S || (w == null || w.scrollIntoView({ block: "nearest" }), w === I && D && (D.scrollTop = 0), w === y && D && (D.scrollTop = D.scrollHeight), w == null || w.focus(), document.activeElement !== S)) return;
      },
      [W, D]
    ), V = t.useCallback(
      () => N([k, h]),
      [N, k, h]
    );
    t.useEffect(() => {
      z && V();
    }, [z, V]);
    const { onOpenChange: j, triggerPointerDownPosRef: Y } = f;
    t.useEffect(() => {
      if (h) {
        let m = { x: 0, y: 0 };
        const I = (y) => {
          var S, w;
          m = {
            x: Math.abs(Math.round(y.pageX) - (((S = Y.current) == null ? void 0 : S.x) ?? 0)),
            y: Math.abs(Math.round(y.pageY) - (((w = Y.current) == null ? void 0 : w.y) ?? 0))
          };
        }, E = (y) => {
          m.x <= 10 && m.y <= 10 ? y.preventDefault() : h.contains(y.target) || j(!1), document.removeEventListener("pointermove", I), Y.current = null;
        };
        return Y.current !== null && (document.addEventListener("pointermove", I), document.addEventListener("pointerup", E, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", I), document.removeEventListener("pointerup", E, { capture: !0 });
        };
      }
    }, [h, j, Y]), t.useEffect(() => {
      const m = () => j(!1);
      return window.addEventListener("blur", m), window.addEventListener("resize", m), () => {
        window.removeEventListener("blur", m), window.removeEventListener("resize", m);
      };
    }, [j]);
    const [me, ie] = ot((m) => {
      const I = W().filter((S) => !S.disabled), E = I.find((S) => S.ref.current === document.activeElement), y = nt(I, m, E);
      y && setTimeout(() => y.ref.current.focus());
    }), he = t.useCallback(
      (m, I, E) => {
        const y = !U.current && !E;
        (f.value !== void 0 && f.value === I || y) && (G(m), y && (U.current = !0));
      },
      [f.value]
    ), ve = t.useCallback(() => h == null ? void 0 : h.focus(), [h]), te = t.useCallback(
      (m, I, E) => {
        const y = !U.current && !E;
        (f.value !== void 0 && f.value === I || y) && F(m);
      },
      [f.value]
    ), ae = c === "popper" ? xe : Ge, re = ae === xe ? {
      side: r,
      sideOffset: n,
      align: p,
      alignOffset: v,
      arrowPadding: C,
      collisionBoundary: _,
      collisionPadding: P,
      sticky: T,
      hideWhenDetached: u,
      avoidCollisions: g
    } : {};
    return /* @__PURE__ */ i(
      Ue,
      {
        scope: e,
        content: h,
        viewport: D,
        onViewportChange: ne,
        itemRefCallback: he,
        selectedItem: k,
        onItemLeave: ve,
        itemTextRefCallback: te,
        focusSelectedItem: V,
        selectedItemText: Z,
        position: c,
        isPositioned: z,
        searchRef: me,
        children: /* @__PURE__ */ i(ft, { as: it, allowPinchZoom: !0, children: /* @__PURE__ */ i(
          mt,
          {
            asChild: !0,
            trapped: f.open,
            onMountAutoFocus: (m) => {
              m.preventDefault();
            },
            onUnmountAutoFocus: b(s, (m) => {
              var I;
              (I = f.trigger) == null || I.focus({ preventScroll: !0 }), m.preventDefault();
            }),
            children: /* @__PURE__ */ i(
              dt,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: d,
                onPointerDownOutside: o,
                onFocusOutside: (m) => m.preventDefault(),
                onDismiss: () => f.onOpenChange(!1),
                children: /* @__PURE__ */ i(
                  ae,
                  {
                    role: "listbox",
                    id: f.contentId,
                    "data-state": f.open ? "open" : "closed",
                    dir: f.dir,
                    onContextMenu: (m) => m.preventDefault(),
                    ...x,
                    ...re,
                    onPlaced: () => K(!0),
                    ref: R,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...x.style
                    },
                    onKeyDown: b(x.onKeyDown, (m) => {
                      const I = m.ctrlKey || m.altKey || m.metaKey;
                      if (m.key === "Tab" && m.preventDefault(), !I && m.key.length === 1 && ie(m.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(m.key)) {
                        let y = W().filter((S) => !S.disabled).map((S) => S.ref.current);
                        if (["ArrowUp", "End"].includes(m.key) && (y = y.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(m.key)) {
                          const S = m.target, w = y.indexOf(S);
                          y = y.slice(w + 1);
                        }
                        setTimeout(() => N(y)), m.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
je.displayName = Nt;
var Et = "SelectItemAlignedPosition", Ge = t.forwardRef((l, a) => {
  const { __scopeSelect: e, onPlaced: c, ...s } = l, d = $(ee, e), o = X(ee, e), [r, n] = t.useState(null), [p, v] = t.useState(null), C = B(a, (R) => v(R)), _ = pe(e), P = t.useRef(!1), T = t.useRef(!0), { viewport: u, selectedItem: g, selectedItemText: x, focusSelectedItem: f } = o, h = t.useCallback(() => {
    if (d.trigger && d.valueNode && r && p && u && g && x) {
      const R = d.trigger.getBoundingClientRect(), k = p.getBoundingClientRect(), G = d.valueNode.getBoundingClientRect(), Z = x.getBoundingClientRect();
      if (d.dir !== "rtl") {
        const S = Z.left - k.left, w = G.left - S, J = R.left - w, Q = R.width + J, ge = Math.max(Q, k.width), Se = window.innerWidth - L, we = Re(w, [
          L,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(L, Se - ge)
        ]);
        r.style.minWidth = Q + "px", r.style.left = we + "px";
      } else {
        const S = k.right - Z.right, w = window.innerWidth - G.right - S, J = window.innerWidth - R.right - w, Q = R.width + J, ge = Math.max(Q, k.width), Se = window.innerWidth - L, we = Re(w, [
          L,
          Math.max(L, Se - ge)
        ]);
        r.style.minWidth = Q + "px", r.style.right = we + "px";
      }
      const F = _(), W = window.innerHeight - L * 2, z = u.scrollHeight, K = window.getComputedStyle(p), U = parseInt(K.borderTopWidth, 10), N = parseInt(K.paddingTop, 10), V = parseInt(K.borderBottomWidth, 10), j = parseInt(K.paddingBottom, 10), Y = U + N + z + j + V, me = Math.min(g.offsetHeight * 5, Y), ie = window.getComputedStyle(u), he = parseInt(ie.paddingTop, 10), ve = parseInt(ie.paddingBottom, 10), te = R.top + R.height / 2 - L, ae = W - te, re = g.offsetHeight / 2, m = g.offsetTop + re, I = U + N + m, E = Y - I;
      if (I <= te) {
        const S = F.length > 0 && g === F[F.length - 1].ref.current;
        r.style.bottom = "0px";
        const w = p.clientHeight - u.offsetTop - u.offsetHeight, J = Math.max(
          ae,
          re + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (S ? ve : 0) + w + V
        ), Q = I + J;
        r.style.height = Q + "px";
      } else {
        const S = F.length > 0 && g === F[0].ref.current;
        r.style.top = "0px";
        const J = Math.max(
          te,
          U + u.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (S ? he : 0) + re
        ) + E;
        r.style.height = J + "px", u.scrollTop = I - te + u.offsetTop;
      }
      r.style.margin = `${L}px 0`, r.style.minHeight = me + "px", r.style.maxHeight = W + "px", c == null || c(), requestAnimationFrame(() => P.current = !0);
    }
  }, [
    _,
    d.trigger,
    d.valueNode,
    r,
    p,
    u,
    g,
    x,
    d.dir,
    c
  ]);
  q(() => h(), [h]);
  const [O, D] = t.useState();
  q(() => {
    p && D(window.getComputedStyle(p).zIndex);
  }, [p]);
  const ne = t.useCallback(
    (R) => {
      R && T.current === !0 && (h(), f == null || f(), T.current = !1);
    },
    [h, f]
  );
  return /* @__PURE__ */ i(
    At,
    {
      scope: e,
      contentWrapper: r,
      shouldExpandOnScrollRef: P,
      onScrollButtonChange: ne,
      children: /* @__PURE__ */ i(
        "div",
        {
          ref: n,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: O
          },
          children: /* @__PURE__ */ i(
            A.div,
            {
              ...s,
              ref: C,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...s.style
              }
            }
          )
        }
      )
    }
  );
});
Ge.displayName = Et;
var Mt = "SelectPopperPosition", xe = t.forwardRef((l, a) => {
  const {
    __scopeSelect: e,
    align: c = "start",
    collisionPadding: s = L,
    ...d
  } = l, o = fe(e);
  return /* @__PURE__ */ i(
    gt,
    {
      ...o,
      ...d,
      ref: a,
      align: c,
      collisionPadding: s,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...d.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
xe.displayName = Mt;
var [At, be] = oe(ee, {}), ye = "SelectViewport", ze = t.forwardRef(
  (l, a) => {
    const { __scopeSelect: e, nonce: c, ...s } = l, d = X(ye, e), o = be(ye, e), r = B(a, d.onViewportChange), n = t.useRef(0);
    return /* @__PURE__ */ H(se, { children: [
      /* @__PURE__ */ i(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: c
        }
      ),
      /* @__PURE__ */ i(ue.Slot, { scope: e, children: /* @__PURE__ */ i(
        A.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...s,
          ref: r,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...s.style
          },
          onScroll: b(s.onScroll, (p) => {
            const v = p.currentTarget, { contentWrapper: C, shouldExpandOnScrollRef: _ } = o;
            if (_ != null && _.current && C) {
              const P = Math.abs(n.current - v.scrollTop);
              if (P > 0) {
                const T = window.innerHeight - L * 2, u = parseFloat(C.style.minHeight), g = parseFloat(C.style.height), x = Math.max(u, g);
                if (x < T) {
                  const f = x + P, h = Math.min(T, f), O = f - h;
                  C.style.height = h + "px", C.style.bottom === "0px" && (v.scrollTop = O > 0 ? O : 0, C.style.justifyContent = "flex-end");
                }
              }
            }
            n.current = v.scrollTop;
          })
        }
      ) })
    ] });
  }
);
ze.displayName = ye;
var Ye = "SelectGroup", [Ot, Dt] = oe(Ye), Lt = t.forwardRef(
  (l, a) => {
    const { __scopeSelect: e, ...c } = l, s = Pe();
    return /* @__PURE__ */ i(Ot, { scope: e, id: s, children: /* @__PURE__ */ i(A.div, { role: "group", "aria-labelledby": s, ...c, ref: a }) });
  }
);
Lt.displayName = Ye;
var qe = "SelectLabel", kt = t.forwardRef(
  (l, a) => {
    const { __scopeSelect: e, ...c } = l, s = Dt(qe, e);
    return /* @__PURE__ */ i(A.div, { id: s.id, ...c, ref: a });
  }
);
kt.displayName = qe;
var de = "SelectItem", [Vt, $e] = oe(de), Xe = t.forwardRef(
  (l, a) => {
    const {
      __scopeSelect: e,
      value: c,
      disabled: s = !1,
      textValue: d,
      ...o
    } = l, r = $(de, e), n = X(de, e), p = r.value === c, [v, C] = t.useState(d ?? ""), [_, P] = t.useState(!1), T = B(
      a,
      (f) => {
        var h;
        return (h = n.itemRefCallback) == null ? void 0 : h.call(n, f, c, s);
      }
    ), u = Pe(), g = t.useRef("touch"), x = () => {
      s || (r.onValueChange(c), r.onOpenChange(!1));
    };
    if (c === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ i(
      Vt,
      {
        scope: e,
        value: c,
        disabled: s,
        textId: u,
        isSelected: p,
        onItemTextChange: t.useCallback((f) => {
          C((h) => h || ((f == null ? void 0 : f.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ i(
          ue.ItemSlot,
          {
            scope: e,
            value: c,
            disabled: s,
            textValue: v,
            children: /* @__PURE__ */ i(
              A.div,
              {
                role: "option",
                "aria-labelledby": u,
                "data-highlighted": _ ? "" : void 0,
                "aria-selected": p && _,
                "data-state": p ? "checked" : "unchecked",
                "aria-disabled": s || void 0,
                "data-disabled": s ? "" : void 0,
                tabIndex: s ? void 0 : -1,
                ...o,
                ref: T,
                onFocus: b(o.onFocus, () => P(!0)),
                onBlur: b(o.onBlur, () => P(!1)),
                onClick: b(o.onClick, () => {
                  g.current !== "mouse" && x();
                }),
                onPointerUp: b(o.onPointerUp, () => {
                  g.current === "mouse" && x();
                }),
                onPointerDown: b(o.onPointerDown, (f) => {
                  g.current = f.pointerType;
                }),
                onPointerMove: b(o.onPointerMove, (f) => {
                  var h;
                  g.current = f.pointerType, s ? (h = n.onItemLeave) == null || h.call(n) : g.current === "mouse" && f.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: b(o.onPointerLeave, (f) => {
                  var h;
                  f.currentTarget === document.activeElement && ((h = n.onItemLeave) == null || h.call(n));
                }),
                onKeyDown: b(o.onKeyDown, (f) => {
                  var O;
                  ((O = n.searchRef) == null ? void 0 : O.current) !== "" && f.key === " " || (yt.includes(f.key) && x(), f.key === " " && f.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
Xe.displayName = de;
var le = "SelectItemText", Ze = t.forwardRef(
  (l, a) => {
    const { __scopeSelect: e, className: c, style: s, ...d } = l, o = $(le, e), r = X(le, e), n = $e(le, e), p = Pt(le, e), [v, C] = t.useState(null), _ = B(
      a,
      (x) => C(x),
      n.onItemTextChange,
      (x) => {
        var f;
        return (f = r.itemTextRefCallback) == null ? void 0 : f.call(r, x, n.value, n.disabled);
      }
    ), P = v == null ? void 0 : v.textContent, T = t.useMemo(
      () => /* @__PURE__ */ i("option", { value: n.value, disabled: n.disabled, children: P }, n.value),
      [n.disabled, n.value, P]
    ), { onNativeOptionAdd: u, onNativeOptionRemove: g } = p;
    return q(() => (u(T), () => g(T)), [u, g, T]), /* @__PURE__ */ H(se, { children: [
      /* @__PURE__ */ i(A.span, { id: n.textId, ...d, ref: _ }),
      n.isSelected && o.valueNode && !o.valueNodeHasChildren ? Oe.createPortal(d.children, o.valueNode) : null
    ] });
  }
);
Ze.displayName = le;
var Je = "SelectItemIndicator", Ht = t.forwardRef(
  (l, a) => {
    const { __scopeSelect: e, ...c } = l;
    return $e(Je, e).isSelected ? /* @__PURE__ */ i(A.span, { "aria-hidden": !0, ...c, ref: a }) : null;
  }
);
Ht.displayName = Je;
var Ie = "SelectScrollUpButton", Bt = t.forwardRef((l, a) => {
  const e = X(Ie, l.__scopeSelect), c = be(Ie, l.__scopeSelect), [s, d] = t.useState(!1), o = B(a, c.onScrollButtonChange);
  return q(() => {
    if (e.viewport && e.isPositioned) {
      let r = function() {
        const p = n.scrollTop > 0;
        d(p);
      };
      const n = e.viewport;
      return r(), n.addEventListener("scroll", r), () => n.removeEventListener("scroll", r);
    }
  }, [e.viewport, e.isPositioned]), s ? /* @__PURE__ */ i(
    Qe,
    {
      ...l,
      ref: o,
      onAutoScroll: () => {
        const { viewport: r, selectedItem: n } = e;
        r && n && (r.scrollTop = r.scrollTop - n.offsetHeight);
      }
    }
  ) : null;
});
Bt.displayName = Ie;
var Te = "SelectScrollDownButton", Ft = t.forwardRef((l, a) => {
  const e = X(Te, l.__scopeSelect), c = be(Te, l.__scopeSelect), [s, d] = t.useState(!1), o = B(a, c.onScrollButtonChange);
  return q(() => {
    if (e.viewport && e.isPositioned) {
      let r = function() {
        const p = n.scrollHeight - n.clientHeight, v = Math.ceil(n.scrollTop) < p;
        d(v);
      };
      const n = e.viewport;
      return r(), n.addEventListener("scroll", r), () => n.removeEventListener("scroll", r);
    }
  }, [e.viewport, e.isPositioned]), s ? /* @__PURE__ */ i(
    Qe,
    {
      ...l,
      ref: o,
      onAutoScroll: () => {
        const { viewport: r, selectedItem: n } = e;
        r && n && (r.scrollTop = r.scrollTop + n.offsetHeight);
      }
    }
  ) : null;
});
Ft.displayName = Te;
var Qe = t.forwardRef((l, a) => {
  const { __scopeSelect: e, onAutoScroll: c, ...s } = l, d = X("SelectScrollButton", e), o = t.useRef(null), r = pe(e), n = t.useCallback(() => {
    o.current !== null && (window.clearInterval(o.current), o.current = null);
  }, []);
  return t.useEffect(() => () => n(), [n]), q(() => {
    var v;
    const p = r().find((C) => C.ref.current === document.activeElement);
    (v = p == null ? void 0 : p.ref.current) == null || v.scrollIntoView({ block: "nearest" });
  }, [r]), /* @__PURE__ */ i(
    A.div,
    {
      "aria-hidden": !0,
      ...s,
      ref: a,
      style: { flexShrink: 0, ...s.style },
      onPointerDown: b(s.onPointerDown, () => {
        o.current === null && (o.current = window.setInterval(c, 50));
      }),
      onPointerMove: b(s.onPointerMove, () => {
        var p;
        (p = d.onItemLeave) == null || p.call(d), o.current === null && (o.current = window.setInterval(c, 50));
      }),
      onPointerLeave: b(s.onPointerLeave, () => {
        n();
      })
    }
  );
}), Wt = "SelectSeparator", Kt = t.forwardRef(
  (l, a) => {
    const { __scopeSelect: e, ...c } = l;
    return /* @__PURE__ */ i(A.div, { "aria-hidden": !0, ...c, ref: a });
  }
);
Kt.displayName = Wt;
var _e = "SelectArrow", Ut = t.forwardRef(
  (l, a) => {
    const { __scopeSelect: e, ...c } = l, s = fe(e), d = $(_e, e), o = X(_e, e);
    return d.open && o.position === "popper" ? /* @__PURE__ */ i(St, { ...s, ...c, ref: a }) : null;
  }
);
Ut.displayName = _e;
function et(l) {
  return l === "" || l === void 0;
}
var tt = t.forwardRef(
  (l, a) => {
    const { value: e, ...c } = l, s = t.useRef(null), d = B(a, s), o = wt(e);
    return t.useEffect(() => {
      const r = s.current, n = window.HTMLSelectElement.prototype, v = Object.getOwnPropertyDescriptor(
        n,
        "value"
      ).set;
      if (o !== e && v) {
        const C = new Event("change", { bubbles: !0 });
        v.call(r, e), r.dispatchEvent(C);
      }
    }, [o, e]), /* @__PURE__ */ i(Ct, { asChild: !0, children: /* @__PURE__ */ i("select", { ...c, ref: d, defaultValue: e }) });
  }
);
tt.displayName = "BubbleSelect";
function ot(l) {
  const a = rt(l), e = t.useRef(""), c = t.useRef(0), s = t.useCallback(
    (o) => {
      const r = e.current + o;
      a(r), function n(p) {
        e.current = p, window.clearTimeout(c.current), p !== "" && (c.current = window.setTimeout(() => n(""), 1e3));
      }(r);
    },
    [a]
  ), d = t.useCallback(() => {
    e.current = "", window.clearTimeout(c.current);
  }, []);
  return t.useEffect(() => () => window.clearTimeout(c.current), []), [e, s, d];
}
function nt(l, a, e) {
  const s = a.length > 1 && Array.from(a).every((p) => p === a[0]) ? a[0] : a, d = e ? l.indexOf(e) : -1;
  let o = jt(l, Math.max(d, 0));
  s.length === 1 && (o = o.filter((p) => p !== e));
  const n = o.find(
    (p) => p.textValue.toLowerCase().startsWith(s.toLowerCase())
  );
  return n !== e ? n : void 0;
}
function jt(l, a) {
  return l.map((e, c) => l[(a + c) % l.length]);
}
var Gt = Le, zt = Ve, Yt = Be, qt = Fe, $t = We, Xt = Ke, Zt = ze, Me = Xe, Ae = Ze;
const Jt = "_disabled_1chjl_43", M = {
  "select-container": "_select-container_1chjl_29",
  "has-error": "_has-error_1chjl_40",
  disabled: Jt,
  "label-helper-text": "_label-helper-text_1chjl_46",
  "select-trigger": "_select-trigger_1chjl_51",
  "select-icon": "_select-icon_1chjl_100",
  "select-content": "_select-content_1chjl_112",
  "select-viewport": "_select-viewport_1chjl_125",
  "select-item": "_select-item_1chjl_129",
  "container-icon": "_container-icon_1chjl_151"
}, ho = ({
  onChange: l,
  value: a,
  suggestions: e,
  placeholder: c,
  label: s,
  labelHelperContent: d,
  hasError: o,
  disabled: r,
  message: n,
  ariaLabel: p
}) => /* @__PURE__ */ H("div", { className: M["select-container"], children: [
  s && /* @__PURE__ */ H(se, { children: [
    /* @__PURE__ */ i("label", { className: Ce(o && M["has-error"], r && M.disabled), children: s }),
    d && /* @__PURE__ */ i("div", { className: M["label-helper-text"], children: d })
  ] }),
  /* @__PURE__ */ H(Gt, { disabled: r, value: a, onValueChange: l, children: [
    /* @__PURE__ */ H(
      zt,
      {
        className: Ce(o && !r && M["has-error"], M["select-trigger"]),
        "aria-label": p,
        children: [
          /* @__PURE__ */ i(Yt, { placeholder: c }),
          /* @__PURE__ */ i(qt, { className: M["select-icon"], children: /* @__PURE__ */ i(Ee, { size: "small", name: "up-arrow" }) })
        ]
      }
    ),
    /* @__PURE__ */ i($t, { children: /* @__PURE__ */ i(Xt, { className: M["select-content"], position: "popper", children: /* @__PURE__ */ H(Zt, { className: M["select-viewport"], children: [
      c && /* @__PURE__ */ i(Me, { className: M["select-item"], value: "header", disabled: !0, children: /* @__PURE__ */ i(Ae, { children: c }) }),
      /* @__PURE__ */ i(se, { children: e == null ? void 0 : e.map((v) => /* @__PURE__ */ i(Me, { className: M["select-item"], value: v.value, children: /* @__PURE__ */ i(Ae, { children: v.value }) }, v.id)) })
    ] }) }) })
  ] }),
  n && o && !r && /* @__PURE__ */ H("div", { className: Ce(o && M["has-error"], M["container-icon"]), children: [
    /* @__PURE__ */ i(Ee, { name: "error-warning-fill", size: "medium" }),
    /* @__PURE__ */ i("span", { children: n })
  ] })
] });
export {
  ho as SelectField
};
